(function () {
  'use strict';

  var activityEvents = ['mousemove', 'mousedown', 'keydown', 'scroll', 'touchstart', 'click', 'wheel'];

  function hasCookie(name) {
    var needle = name + '=';
    return document.cookie.split(';').some(function (part) {
      return part.trim().indexOf(needle) === 0;
    });
  }

  function initLightbox(lightbox) {
    if (!lightbox || lightbox.getAttribute('data-signup-lightbox-ready') === 'true') return;
    lightbox.setAttribute('data-signup-lightbox-ready', 'true');

    var cookieName = lightbox.getAttribute('data-cookie-name') || 'signup-lightbox-dismissed';
    var designMode = lightbox.getAttribute('data-design-mode') === 'true';
    var trigger = lightbox.getAttribute('data-trigger') || 'timer';
    var delaySeconds = parseInt(lightbox.getAttribute('data-delay'), 10);
    var cookieDays = parseInt(lightbox.getAttribute('data-cookie-days'), 10);
    var showTimer = null;
    var onKeydown = null;

    if (isNaN(delaySeconds)) delaySeconds = trigger === 'inactivity' ? 60 : 20;
    if (isNaN(cookieDays) || cookieDays < 1) cookieDays = 28;

    function setDismissCookie() {
      var expires = new Date();
      expires.setDate(expires.getDate() + cookieDays);
      document.cookie = cookieName + '=1; expires=' + expires.toUTCString() + '; path=/; SameSite=Lax';
    }

    function stopInactivityWatch() {
      activityEvents.forEach(function (eventName) {
        window.removeEventListener(eventName, scheduleFromActivity);
      });
    }

    function dismiss(setCookie) {
      window.clearTimeout(showTimer);
      stopInactivityWatch();
      if (onKeydown) document.removeEventListener('keydown', onKeydown);
      document.documentElement.classList.remove('signup-lightbox-open');
      if (setCookie && !designMode) setDismissCookie();
      document.dispatchEvent(new CustomEvent('signup-lightbox:dismissed'));
      window.setTimeout(function () {
        lightbox.remove();
      }, 0);
    }

    function trapFocus(event) {
      if (event.key !== 'Tab') return;
      var focusable = lightbox.querySelectorAll('a[href], button:not([disabled])');
      if (!focusable.length) return;
      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }

    function showLightbox() {
      window.clearTimeout(showTimer);
      stopInactivityWatch();
      lightbox.classList.add('is-visible');
      document.documentElement.setAttribute('data-signup-lightbox-opened', 'true');
      document.dispatchEvent(new CustomEvent('signup-lightbox:opened'));
      var dialog = lightbox.querySelector('.signup-lightbox__dialog');
      if (dialog) dialog.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('signup-lightbox-open');

      onKeydown = function (event) {
        if (event.key === 'Escape') {
          dismiss(false);
          return;
        }
        trapFocus(event);
      };
      document.addEventListener('keydown', onKeydown);
    }

    function scheduleFromActivity() {
      window.clearTimeout(showTimer);
      showTimer = window.setTimeout(showLightbox, delaySeconds * 1000);
    }

    if (!designMode && hasCookie(cookieName)) {
      lightbox.remove();
      return;
    }

    var closeButton = lightbox.querySelector('[data-signup-lightbox-close]');
    if (closeButton) {
      closeButton.addEventListener('click', function () {
        dismiss(true);
      });
    }

    var overlay = lightbox.querySelector('[data-signup-lightbox-overlay]');
    if (overlay) {
      overlay.addEventListener('click', function (event) {
        if (event.target.closest('.signup-lightbox__dialog')) return;
        dismiss(false);
      });
    }

    var cta = lightbox.querySelector('[data-signup-lightbox-cta]');
    if (cta) {
      cta.addEventListener('click', function () {
        dismiss(true);
      });
    }

    if (designMode) {
      showLightbox();
      return;
    }

    if (trigger === 'inactivity') {
      activityEvents.forEach(function (eventName) {
        window.addEventListener(eventName, scheduleFromActivity, { passive: true });
      });
      scheduleFromActivity();
      return;
    }

    showTimer = window.setTimeout(showLightbox, delaySeconds * 1000);
  }

  function init() {
    var lightbox = document.querySelector('[data-signup-lightbox]');
    if (lightbox) initLightbox(lightbox);
  }

  init();

  document.addEventListener('shopify:section:load', function (event) {
    var lightbox = event.target.querySelector('[data-signup-lightbox]');
    if (lightbox) initLightbox(lightbox);
  });
})();
